import type { PropsWithChildren } from "react";
import { Box } from "@material-ui/core";

const ErrorBoundaryCustomContainer = ({ children }: PropsWithChildren) => (
  <Box height="100vh">
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      pb={24}
      height="100%"
    >
      {children}
    </Box>
  </Box>
);

export default ErrorBoundaryCustomContainer;
